import type { LucideIcon } from 'lucide-react'
import * as React from 'react'
import { forwardRef } from 'react'

export const BookRowRightChevronIcon: LucideIcon = forwardRef(({ size = 39, color = '#D5E7F8', ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={(Number(size) * 154) / 39}
      viewBox='0 0 39 154'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M38.2987 74.8411C38.8088 76.2002 38.8088 77.6982 38.2987 79.0573L11.7073 149.915C9.36065 156.168 0.0898438 154.486 0.0898438 147.807L0.0898438 6.09125C0.0898438 -0.587711 9.36064 -2.26999 11.7073 3.98315L38.2987 74.8411Z'
        fill={color}
      />
    </svg>
  )
})

BookRowRightChevronIcon.displayName = 'BookRowRightChevronIcon'
